import React from "react";

const ModalCloseButton = ({ className = "", type = "button", ...props }) => {
  const classNames = ["uido-modal-close", className].filter(Boolean).join(" ");

  return (
    <button type={type} className={classNames} {...props}>
      <span className="uido-modal-close__control" aria-hidden="true">
        <svg
          className="uido-modal-close__icon"
          width="18"
          height="18"
          viewBox="0 0 18 18"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M0.70622 16.7083L1.41336 17.4154L17.4103 1.41996L16.7031 0.712891L15.996 0.00581646L-0.000919733 16.0012L0.70622 16.7083Z"
            fill="currentColor"
          />
          <path
            d="M0.715987 0.707693L0.00884718 1.41477L16.0058 17.4102L16.7129 16.7031L17.42 15.9961L1.42313 0.00061931L0.715987 0.707693Z"
            fill="currentColor"
          />
        </svg>
      </span>
      <span className="uido-modal-close__line" aria-hidden="true" />
    </button>
  );
};

export default ModalCloseButton;
